import { ID } from '@datorama/akita';

import { Deserializable } from '../../shared/models/deserializable.model';

export class Goal implements Deserializable {
  id: ID;
  name: string;
  tags: string;

  deserialize(input: any) {
    Object.assign(this, input);
    return this;
  }
}
